import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=65d68006&scoped=true&"
import script from "./orderTable.vue?vue&type=script&lang=js&"
export * from "./orderTable.vue?vue&type=script&lang=js&"
import style0 from "./orderTable.vue?vue&type=style&index=0&id=65d68006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d68006",
  null
  
)

export default component.exports